/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ByAddressRequestBuilderRequestsMetadata, type ByAddressRequestBuilder } from './byAddress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /addresses
 */
export interface AddressesRequestBuilder extends BaseRequestBuilder<AddressesRequestBuilder> {
    /**
     * The byAddress property
     */
    get byAddress(): ByAddressRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AddressesRequestBuilderUriTemplate = "{+baseurl}/addresses";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AddressesRequestBuilderNavigationMetadata: Record<Exclude<keyof AddressesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAddress: {
        requestsMetadata: ByAddressRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
